import React, { FC, PropsWithChildren, useState, MouseEvent } from 'react';


// mui ...
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { useRecoilState, useRecoilValue } from 'recoil';

import { Breakpoint, useTheme } from '@mui/system';
import { Divider, useMediaQuery } from '@mui/material';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { currentUserSessionAtom } from 'library/store';


export interface FormDialogProps {
  open: boolean;
  title: string;

  okText: string;
  cancelText: string;

  okButtonDisabled?: boolean,

  fullWidth?: boolean;
  maxWidth?: Breakpoint;

  height?: string,


  onCancel: () => void;
  onOk: (event: MouseEvent<HTMLButtonElement>) => void;
  onClose: () => void;
}



type ActionFunc = () => void;

const styles = {
  dialogPaper: {
    minHeight: '80vh',
    maxHeight: '80vh',
  },
};


export function FormDialog(props: PropsWithChildren<FormDialogProps>) {

  const { isAuthenticated } = useRecoilValue(currentUserSessionAtom);

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.up('xs'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));

  const sz = isXl ? 'xl' : isLg ? 'lg' : isMd ? 'md' : isSm ? 'sm' : 'xs';

  const { open, title, okText, cancelText, onOk, onCancel, onClose, fullWidth, maxWidth, height,
    okButtonDisabled, children } = props;
  return (
    <Dialog open={isAuthenticated && open} onClose={onClose} PaperProps={{
      sx: {
        height: height || '90vh',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
      }
    }}
      maxWidth={maxWidth ? maxWidth : sz} fullWidth={(fullWidth === undefined) ? true : fullWidth}>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 1,
        }}
      >{title}
        <IconButton size="small" onClick={onClose}>
          <CloseIcon />
        </IconButton></DialogTitle>
      <Divider />
      <DialogContent sx={{
          flex: 1,
          overflowY: 'auto',
          py: 2,
        }}>
        {children}
        
      </DialogContent>
      <DialogActions sx={{
          px: 2,
          py: 1.5,
          justifyContent: 'flex-end',
          gap: 1,
        }}>
        {cancelText !== '' ? <Button variant="outlined" onClick={onCancel} sx={{ mb: 2, ml: 1 }}>{cancelText}</Button> : null}
        {okText !== '' ? <Button variant="contained" onClick={onOk} sx={{ mb: 2, ml: 4 }} disabled={okButtonDisabled || false} >{okText}</Button> : null}
      </DialogActions>
    </Dialog>);
}


/*
interface UseFormDialogProps {
    
    title : string;    

    okText: string;
    cancelText: string;

    onCancel: () => void;
    onOk: () => void;
    onClose: () => void;
}


export const useFormDialog = (onOk: ActionFunc ) => {

  const [open, setOpen] = useState(false);

  function show() {
    setOpen(true);
  }

  function hide() {
    setOpen(false);
  }

  return {
    open,

    onOk,
    show,
    hide,

  }
} */